/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { useMemo, useState } from 'react';
import { styled } from 'linaria/lib/react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { theme, useBreakpoint } from '@mtsbank/ui-kit';
import BannerDesktopFOG from '@asserts/images/cyber/mainSlider/BannerDesktopFOG.jpg';
import BannerTabletFOG from '@asserts/images/cyber/mainSlider/BannerTabletFOG.jpg';
import BannerMobileFOG from '@asserts/images/cyber/mainSlider/BannerMobileFOG.jpg';
import vesenniiBanerDesktop from '@asserts/images/cyber/mainSlider/vesenniiBanerDesktop.jpg';
import vesenniiBanerTablet from '@asserts/images/cyber/mainSlider/vesenniiBanerTablet.jpg';
import vesenniiBanerMobile from '@asserts/images/cyber/mainSlider/vesenniiBanerMobile.jpg';
import vesenniiItogiDesktop from '@asserts/images/cyber/mainSlider/vesenniiBannerItogiDesktop.jpg';
import vesenniiItogiTablet from '@asserts/images/cyber/mainSlider/vesenniiBannerItogiTablet.jpg';
import vesenniiItogiMobile from '@asserts/images/cyber/mainSlider/vesenniiBannerItogiMobile.jpg';
import BannerDesktopPubg from '@asserts/images/cyber/mainSlider/pubgDesktopBanner.jpg';
import BannerTabletPubg from '@asserts/images/cyber/mainSlider/pubgTabletBanner.jpg';
import BannerMobilePubg from '@asserts/images/cyber/mainSlider/pubgMobileBanner.jpg';
import BannerDesktopPS from '@asserts/images/cyber/mainSlider/BannerDesktopPS.jpg';
import BannerTabletPS from '@asserts/images/cyber/mainSlider/BannerTabletPS.jpg';
import BannerMobilePS from '@asserts/images/cyber/mainSlider/BannerMobilePS.jpg';
import { sliderMainClickGtm } from '@root/utils/gtm/cyber/events';
import { Carousel } from '../Uikit/CarouselMain';
import { PaymentButton } from './buttons/PaymentButton';
import { MTS_FOG_PLAY } from './constansts';
export const Sliderbanner = () => {
  const [, setSlide] = useState(0);
  const navHandler = (id: number) => setSlide(id);
  const {
    isMobile,
    isTablet
  } = useBreakpoint();
  const router = useRouter();
  const blocks = [{
    imageDesktop: vesenniiItogiDesktop,
    imageTablet: vesenniiItogiTablet,
    imageMobile: vesenniiItogiMobile,
    button: <PaymentButton slider vesenniiRozygrysh type="button" title="посмотреть результаты" onClick={e => {
      e.stopPropagation();
      router.push('/rozygrysh-prizov-itogi');
      sliderMainClickGtm('rozygrysh-prizov-itogi');
    }} />,
    onClick: () => {
      router.push('/rozygrysh-prizov-itogi');
      sliderMainClickGtm('rozygrysh-prizov-itogi');
    }
  },
  // {
  //   imageDesktop: vesenniiBanerDesktop,
  //   imageTablet: vesenniiBanerTablet,
  //   imageMobile: vesenniiBanerMobile,
  //   button: (
  //     <PaymentButton
  //       slider
  //       vesenniiRozygrysh
  //       type="button"
  //       title="участвовать"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/rozygrysh-prizov')
  //         sliderMainClickGtm('rozygrysh-prizov')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/rozygrysh-prizov')
  //     sliderMainClickGtm('rozygrysh-prizov')
  //   },
  // },
  // {
  //   imageDesktop: BannerDesktopPS,
  //   imageTablet: BannerTabletPS,
  //   imageMobile: BannerMobilePS,
  //   button: (
  //     <PaymentButton
  //       slider
  //       type="button"
  //       title="ПОПОЛНИТЬ АККАУНТ"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/playstation-network')
  //         sliderMainClickGtm('Playstation-Turkey')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/playstation-network')
  //     sliderMainClickGtm('Playstation-Turkey')
  //   },
  // },
  {
    imageDesktop: BannerDesktopPubg,
    imageTablet: BannerTabletPubg,
    imageMobile: BannerMobilePubg,
    button: <PaymentButton slider pubg type="button" title="пополнить аккаунт" onClick={e => {
      e.stopPropagation();
      router.push('/pubg-mobile');
      sliderMainClickGtm('pubg-mobile');
    }} />,
    onClick: () => {
      router.push('/pubg-mobile');
      sliderMainClickGtm('pubg-mobile');
    }
  },
  // {
  //   imageDesktop: BannerDesktopItogiNG,
  //   imageTablet: BannerTabletItogiNG,
  //   imageMobile: BannerMobileItogiNG,
  //   button: (
  //     <PaymentButton
  //       slider
  //       inarius
  //       type="button"
  //       title="посмотреть результаты"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/novogodniy-rozygrysh-prizov-itogi')
  //         sliderMainClickGtm('novogodniy-rozygrysh-prizov-itogi')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/novogodniy-rozygrysh-prizov-itogi')
  //     sliderMainClickGtm('novogodniy-rozygrysh-prizov-itogi')
  //   },
  // },
  // {
  //   imageDesktop: BannerDesktopDiabloInariusResult,
  //   imageTablet: BannerTabletDiabloInariusResult,
  //   imageMobile: BannerMobileDiabloInariusResult,
  //   button: (
  //     <PaymentButton
  //       slider
  //       inarius
  //       type="button"
  //       title="ПОСМОТРЕТЬ РЕЗУЛЬТАТЫ"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/promo-inarius-itogy')
  //         sliderMainClickGtm('Promo-inarius-itogy')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/promo-inarius-itogy')
  //     sliderMainClickGtm('Promo-inarius-itogy')
  //   },
  // },
  // {
  //   imageDesktop: FinalTournamentDesktop,
  //   imageTablet: FinalTournamentTablet,
  //   imageMobile: FinalTournamentMobile,
  //   button: (
  //     <PaymentButton
  //       slider
  //       type="button"
  //       title="СМОТРЕТЬ"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push(FINAL_TOURNAMENT)
  //         sliderMainClickGtm('final-tournament')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push(FINAL_TOURNAMENT)
  //     sliderMainClickGtm('final-tournament')
  //   },
  // },
  // {
  //   imageDesktop: BannerDesktopGenshin,
  //   imageTablet: BannerTabletGenshin,
  //   imageMobile: BannerMobileGenshin,
  //   button: (
  //     <PaymentButton
  //       slider
  //       genshin
  //       type="button"
  //       title="ПОПОЛНИТЬ АККАУНТ"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/genshin')
  //         sliderMainClickGtm('genshin')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/genshin')
  //     sliderMainClickGtm('genshin')
  //   },
  // },
  // {
  //   imageDesktop: CardMirDesktop,
  //   imageTablet: CardMirTablet,
  //   imageMobile: CardMirMobile,
  //   button: (
  //     <PaymentButton
  //       slider
  //       type="button"
  //       title="ПОДРОБНЕЕ"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/mts-cashback-lite-mir')
  //         sliderMainClickGtm('mts-cashback-lite-mir')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/mts-cashback-lite-mir')
  //     sliderMainClickGtm('mts-cashback-lite-mir')
  //   },
  // },
  // {
  //   imageDesktop: BannerDesktopSTEAM,
  //   imageTablet: BannerTabletSTEAM,
  //   imageMobile: BannerMobileSTEAM,
  //   button: (
  //     <PaymentButton
  //       slider
  //       type="button"
  //       title="ПОПОЛНИТЬ STEAM"
  //       onClick={(e) => {
  //         e.stopPropagation()
  //         router.push('/steam')
  //         sliderMainClickGtm('Steam')
  //       }}
  //     />
  //   ),
  //   onClick: () => {
  //     router.push('/steam')
  //     sliderMainClickGtm('Steam')
  //   },
  // },
  {
    imageDesktop: BannerDesktopFOG,
    imageTablet: BannerTabletFOG,
    imageMobile: BannerMobileFOG,
    button: <PaymentButton slider mtsFog type="button" title="ИГРАТЬ" onClick={e => {
      e.stopPropagation();
      router.push(MTS_FOG_PLAY);
      sliderMainClickGtm('Fog play');
    }} />,
    onClick: () => {
      router.push(MTS_FOG_PLAY);
      sliderMainClickGtm('Fog play');
    }
  }];
  const mobileBlocks = 1;
  const tabletBlocks = 1;
  const desktopBlocks = 1;
  const makeSlides = (length: number) => blocks?.length ? Array.from({
    length: Math.ceil(blocks.length / length)
  }, (_, i) => i + 1) : [];
  const renderSlideFn = (blocksSize: number, subtractIndex = false) => (part: number, index: number) => <SlideWrapper key={part}>
          {blocks.slice((part - 1) * blocksSize - (subtractIndex ? index : 0), part * blocksSize - (subtractIndex ? index : 0)).map(({
      imageDesktop,
      imageTablet,
      imageMobile,
      button,
      onClick
    }, idx) => <Slide key={idx} style={{
      cursor: 'pointer'
    }} onClick={onClick}>
                <BannerMobileWrapper>
                  <Image priority src={imageMobile} alt="banner" width={402} height={360} style={{
          borderRadius: '32px'
        }} />
                  <WrapperButton>{button}</WrapperButton>
                </BannerMobileWrapper>
                <BannerTabletWrapper>
                  <Image priority src={imageTablet} alt="banner" width={720} height={280} style={{
          borderRadius: '32px'
        }} />
                  <WrapperButton>{button}</WrapperButton>
                </BannerTabletWrapper>
                <BannerMainWrapper>
                  <Image priority src={imageDesktop} alt="banner" width={1016} height={320} style={{
          borderRadius: '32px'
        }} />
                  <WrapperButton>{button}</WrapperButton>
                </BannerMainWrapper>
              </Slide>)}
        </SlideWrapper>;
  const slides = isMobile ? makeSlides(1).map(renderSlideFn(mobileBlocks)) : isTablet ? makeSlides(1).map(renderSlideFn(tabletBlocks)) : makeSlides(desktopBlocks).map(renderSlideFn(desktopBlocks));
  return <CarouselWrapper>
      <Carousel loopSwipe withControls autoplay withDots controlsPosition="bottom" nextHandler={navHandler} prevHandler={navHandler} delay={16000}>
        {useMemo(() => [...slides], [slides])}
      </Carousel>
    </CarouselWrapper>;
};
const CarouselWrapper = /*#__PURE__*/styled("div")({
  name: "CarouselWrapper",
  class: "cf0ipha"
});
const SlideWrapper = /*#__PURE__*/styled("div")({
  name: "SlideWrapper",
  class: "sypf66c"
});
const BannerMobileWrapper = /*#__PURE__*/styled("div")({
  name: "BannerMobileWrapper",
  class: "b1df5ua6"
});
const BannerTabletWrapper = /*#__PURE__*/styled("div")({
  name: "BannerTabletWrapper",
  class: "b1k4ek9h"
});
const BannerMainWrapper = /*#__PURE__*/styled("div")({
  name: "BannerMainWrapper",
  class: "b1nyw4f4"
});
const WrapperButton = /*#__PURE__*/styled("div")({
  name: "WrapperButton",
  class: "w1ktgl8h"
});
const Slide = /*#__PURE__*/styled("div")({
  name: "Slide",
  class: "svyh1os"
});

require("./SliderBanner.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./SliderBanner.tsx");